import { useMutation } from "@apollo/client";
import {
  ClientMarkAllNotificationAsReadDocument,
  ClientNotificationByFiltersDocument,
  ClientUnreadNotificationCountDocument,
} from "@/__generated__/graphql";
import { useAuthState } from "@/store/auth";

export const useMarkAllAsReadNotificationMutation = () => {
  const mutation = useMutation(ClientMarkAllNotificationAsReadDocument, {
    refetchQueries: [
      {
        query: ClientNotificationByFiltersDocument,
        variables: { filters: { isRead: true } },
      },
      { query: ClientUnreadNotificationCountDocument },
    ],
    awaitRefetchQueries: true,
    update: () => {
      useAuthState.getState().setUnreadNotificationCount(0);
    },
  });

  return mutation;
};
